const menuRelatorios = [
    {
        title: "Geral",
        icon: "description",
        id: 1,
        permissions: ["admin", "master", "regular", "consulta"],
    },
    {
        title: "Faturas de concessionárias",
        icon: "house",
        id: 2,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Status de usinas",
        icon: "factory",
        id: 3,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Instalações canceladas",
        icon: "disabled",
        id: 4,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Histórico de consumo",
        icon: "autoStories",
        id: 5,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Consolidado e Provisão",
        icon: "menuBook",
        id: 6,
        permissions: ["admin", "master", "regular"],
    },
    // {
    //     title: "Faturas publicadas",
    //     icon: "receiptLong",
    //     id: 8,
    //     permissions: ["admin", "master", "regular"],
    // },
    {
        title: "Faturas pendentes",
        icon: "receipt",
        id: 9,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Formas faturamento",
        icon: "calculate",
        id: 10,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Faturas de clientes",
        icon: "contactPage",
        id: 11,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Rebalance: Movimentações de Ucs",
        icon: "requestPage",
        id: 12,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Rebalance: Geração das usinas",
        icon: "dateRange",
        id: 13,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Rebalance: Usinas",
        icon: "dateRange",
        id: 14,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Refaturamento",
        icon: "",
        id: 16,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Dedução e acréscimo",
        icon: "",
        id: 17,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Cobrança de Saldo Churn",
        icon: "requestQuote",
        id: 18,
        permissions: ["admin", "master", "regular"],
    },
    {
        title: "Resumo do Faturamento",
        icon: "description",
        id: 19,
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
    },
    {
        title: "Parâmetros Rebate",
        icon: "list",
        id: 20,
        permissions: ["admin"],
    },
    {
        title: "Cálculo do Rebate",
        icon: "chart",
        id: 21,
        permissions: ["admin", "master"],
    },
    {
        title: "Parâmetros",
        icon: "grading",
        id: 23,
        permissions: ["admin", "master"],
    },
    {
        title: "Bonificações",
        icon: "dataset",
        id: 22,
        permissions: ["admin", "master"],
    },
    {
        title: "Rebalance: Consolidação de clientes",
        icon: "accountCircle",
        id: 24,
        permissions: ["admin", "master"],
    },
    {
        title: "Faturamento Gerencial",
        icon: "payments",
        id: 25,
        permissions: ["admin", "master"],
    },
];

export default menuRelatorios;
